import {
  FETCH_CARE_HEARTH_BUYER,
  FETCH_CARE_HEARTH_BUYER_FAILURE,
  FETCH_CARE_HEARTH_BUYER_SUCCESS,
  FETCH_CARE_HEARTH_BUYERS,
  FETCH_CARE_HEARTH_BUYERS_FAILURE,
  FETCH_CARE_HEARTH_BUYERS_SUCCESS,
  FETCH_CARE_HEARTH_DISPUTES,
  FETCH_CARE_HEARTH_DISPUTES_FAILURE,
  FETCH_CARE_HEARTH_DISPUTES_SUCCESS,
  FETCH_CARE_HEARTH_INVOICES,
  FETCH_CARE_HEARTH_INVOICES_FAILURE,
  FETCH_CARE_HEARTH_INVOICES_SUCCESS,
  MARK_CARE_HEARTH_INVOICE_PAID,
  MARK_CARE_HEARTH_INVOICE_PAID_FAILURE,
  MARK_CARE_HEARTH_INVOICE_PAID_SUCCESS,
  RAISE_CARE_HEARTH_DISPUTES,
  RAISE_CARE_HEARTH_DISPUTES_FAILURE,
  RAISE_CARE_HEARTH_DISPUTES_SUCCESS,
  RECALCULATE_CARE_HEARTH_BUYER,
  RECALCULATE_CARE_HEARTH_BUYER_FAILURE,
  RECALCULATE_CARE_HEARTH_BUYER_SUCCESS,
} from "./constants";

const action = (type) => (payload) => ({ type, payload });

export const fetchCareHearthBuyers = action(FETCH_CARE_HEARTH_BUYERS);
export const fetchCareHearthBuyersSuccess = action(
  FETCH_CARE_HEARTH_BUYERS_SUCCESS,
);
export const fetchCareHearthBuyersFailure = action(
  FETCH_CARE_HEARTH_BUYERS_FAILURE,
);

export const fetchCareHearthBuyer = action(FETCH_CARE_HEARTH_BUYER);
export const fetchCareHearthBuyerSuccess = action(
  FETCH_CARE_HEARTH_BUYER_SUCCESS,
);
export const fetchCareHearthBuyerFailure = action(
  FETCH_CARE_HEARTH_BUYER_FAILURE,
);

export const recalculateCareHearthBuyer = action(RECALCULATE_CARE_HEARTH_BUYER);
export const recalculateCareHearthBuyerSuccess = action(
  RECALCULATE_CARE_HEARTH_BUYER_SUCCESS,
);
export const recalculateCareHearthBuyerFailure = action(
  RECALCULATE_CARE_HEARTH_BUYER_FAILURE,
);

export const fetchCareHearthInvoices = action(FETCH_CARE_HEARTH_INVOICES);
export const fetchCareHearthInvoicesSuccess = action(
  FETCH_CARE_HEARTH_INVOICES_SUCCESS,
);
export const fetchCareHearthInvoicesFailure = action(
  FETCH_CARE_HEARTH_INVOICES_FAILURE,
);

// payload: { uuid, locationId } from a buyer's page, or { uuid, params } from
// the invoices list; either is reloaded afterwards.
export const markCareHearthInvoicePaid = action(MARK_CARE_HEARTH_INVOICE_PAID);
export const markCareHearthInvoicePaidSuccess = action(
  MARK_CARE_HEARTH_INVOICE_PAID_SUCCESS,
);
export const markCareHearthInvoicePaidFailure = action(
  MARK_CARE_HEARTH_INVOICE_PAID_FAILURE,
);

// payload: the list's params (month, location_id, status, page).
export const fetchCareHearthDisputes = action(FETCH_CARE_HEARTH_DISPUTES);
export const fetchCareHearthDisputesSuccess = action(
  FETCH_CARE_HEARTH_DISPUTES_SUCCESS,
);
export const fetchCareHearthDisputesFailure = action(
  FETCH_CARE_HEARTH_DISPUTES_FAILURE,
);

// payload: { body: { location_id, offer_uuids, reason, note }, params }: the
// list is reloaded with params afterwards.
export const raiseCareHearthDisputes = action(RAISE_CARE_HEARTH_DISPUTES);
export const raiseCareHearthDisputesSuccess = action(
  RAISE_CARE_HEARTH_DISPUTES_SUCCESS,
);
export const raiseCareHearthDisputesFailure = action(
  RAISE_CARE_HEARTH_DISPUTES_FAILURE,
);
